<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">

            <!-- Start Create Subscription Album -->
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 pt-2">
                            <h3 class="breadcrumb-title pe-4 pt-3"><span [translate]="'GREATER.PASSWORD_SECURITY'"> </span>
                                <span class="ps-3 tooltip-btn"  matTooltip="{{'GREATER.PASSWORD_LENGTH_CHECK'  | translate}}">
                                    <i class="gricon gr_ic_info"></i>
                                </span> </h3>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <!-- Section Wrap Start -->
                <section class="inner-section-wrap dark-bg p-4 border-radius5">
                    <div class="custom-form custom-form-2">
                        <form [formGroup]="ResetData" (ngSubmit)="Onsubmit()">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2  text-uppercase" for="OldPassword"><span [translate]="'GREATER.OLD_PASSWORD'"> </span>  </label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field" minlength="8" placeholder="***********" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password')"> 
                                                <i class="fa-regular fa-eye-slash toggle-password" toggle="#password-field"></i>
                                                <!-- <i class="fa-regular fa-eye-slash toggle--password" toggle="#password-field"></i> -->
                                            </span>
                                        </div>
                                        <!-- <span class="d-block pt-2 grey-color font-12" [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span> -->
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.password.errors"> 
                                            <div *ngIf="f['password'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                            <div *ngIf="f['password'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2  text-uppercase" for="NewPassword"><span [translate]="'GREATER.NEW_PASSWORD'"> </span> </label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field1" minlength="8" placeholder="***********" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="npassword" [ngClass]="{ 'is-invalid': submitted && f.npassword.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password1')"> 
                                                <i class="fa-regular fa-eye-slash toggle-password1" toggle="#password-field1"></i>
                                                <!-- <i class="fa-regular fa-eye-slash toggle--password" toggle="#password-field"></i> -->
                                            </span>
                                        </div>
                                        <!-- <span class="d-block pt-2 grey-color font-12" [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span> -->
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.npassword.errors"> 
                                            <div *ngIf="f['npassword'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                            <div *ngIf="f['npassword'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2  text-uppercase" for="ConfirmPassword"><span [translate]="'GREATER.CONFIRM_PASSWORD'"> </span> </label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field2" minlength="8" placeholder="***********" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="cpassword" [ngClass]="{ 'is-invalid': submitted && f.cpassword.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password2')"> 
                                                <i class="fa-regular fa-eye-slash toggle-password2" toggle="#password-field2"></i>
                                                <!-- <i class="fa-regular fa-eye-slash toggle--password" toggle="#password-field"></i> -->
                                            </span>
                                        </div>
                                        <!-- <span class="d-block pt-2 grey-color font-12" [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span> -->
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.cpassword.errors"> 
                                            <div *ngIf="f['cpassword'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                            <div *ngIf="f['cpassword'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="btn-box">
                                        <button type="submit" class="btn custom-btn gradient1-btn"> <span [translate]="'GREATER.UPDATE'"> </span> </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>

            </div>
        </div>
    </div>
    <app-footer></app-footer>
</main>